import { render, staticRenderFns } from "./admin_modify_msnn_mgr.vue?vue&type=template&id=d51903ce&"
import script from "./admin_modify_msnn_mgr.vue?vue&type=script&lang=js&"
export * from "./admin_modify_msnn_mgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports